import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'
import './lib/i18n' // Initialize i18n
import { initChunkLoadErrorHandler } from './utils/chunkLoadErrorHandler'
import { registerSW } from 'virtual:pwa-register'

// Initialize global chunk load error handler for production
// This automatically retries or reloads when JS chunks fail to load
initChunkLoadErrorHandler();

// In development: clear any stale service workers and caches to ensure fresh code
// In production: register PWA Service Worker for offline functionality
if (import.meta.env.DEV) {
  // Development mode: unregister any existing service workers and clear caches
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
        console.log('[DEV] Unregistered stale service worker');
      });
    });
    // Clear all caches to prevent stale JS bundles
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
        if (names.length > 0) {
          console.log('[DEV] Cleared', names.length, 'stale caches');
        }
      });
    }
  }
} else {
  // Production mode: register PWA Service Worker
  const updateSW = registerSW({
    onNeedRefresh() {
      console.log('[PWA] New content available, please refresh');
      window.dispatchEvent(new CustomEvent('pwa-update-available', { detail: { updateSW } }));
    },
    onOfflineReady() {
      console.log('[PWA] App ready to work offline');
    },
    onRegistered(registration) {
      console.log('[PWA] Service Worker registered:', registration);
    },
    onRegisterError(error) {
      console.error('[PWA] Service Worker registration error:', error);
    },
  });

  // Make updateSW available globally for the update prompt
  (window as any).__PWA_UPDATE_SW__ = updateSW;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
